import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getReservationPreferencesAPI } from "api/reservation";

/* =========================
   FETCH RESERVATION PREFERENCES
========================= */

export const getReservationPreferences = createAsyncThunk(
  "reservation/getReservationPreferences",
  async ({ hotelId, reservationId }, { rejectWithValue }) => {
    try {
      const response = await getReservationPreferencesAPI(hotelId, reservationId);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const initialState = {
  reservationPreferences: null,

  preferencesLoading: false,
  preferencesError: null,
};

const reservationSlice = createSlice({
  name: "reservation",
  initialState,
  reducers: {
    clearReservationPreferences: (state) => {
      state.reservationPreferences = null;
      state.preferencesError = null;
    },
  },
  extraReducers: (builder) => {
    builder

      /* GET RESERVATION PREFERENCES */

      .addCase(getReservationPreferences.pending, (state) => {
        state.preferencesLoading = true;
      })

      .addCase(getReservationPreferences.fulfilled, (state, action) => {
        state.preferencesLoading = false;
        state.reservationPreferences = action.payload?.data?.preference || null;
      })

      .addCase(getReservationPreferences.rejected, (state, action) => {
        state.preferencesLoading = false;
        state.preferencesError = action.payload || "Failed to load preferences";
      });
  },
});

export const { clearReservationPreferences } = reservationSlice.actions;

export default reservationSlice.reducer;
